function MedispaLocationsFilter() {
  var self = this;

  this.getQueryStringValue = function (key) {
    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.get(key);
  };

  function updateDropdownData(matchedLocations) {
    const bookingsWrapper = jQuery(".booking-wrapper").eq(0);

    // Update location-count
    const dropdownTrigger = bookingsWrapper.find(".medispa-dropdown-trigger");

    if (!dropdownTrigger.length) return;

    dropdownTrigger.attr("data-product-count", matchedLocations.length);

    const dropdownOptionsWrapper = bookingsWrapper.find(
      ".medispa-dropdown-options",
    );

    // Replace productData with the new filtered info
    window.productData = [];

    // If only one location is matched, remove .medispa-dropdown-options, remove the dropdown arrow and set data-action="open-calendar", data-product-id="7447575232695", and data-variant-id="42112921174199"
    if (matchedLocations.length === 1) {
      const location = matchedLocations[0];

      window.productData.push(
        jQuery(location.element).data("product"),
      );

      dropdownOptionsWrapper.remove();

      dropdownTrigger.find(".Icon--chevron-down-outline").remove();
      dropdownTrigger.attr("data-action", "open-calendar");
      dropdownTrigger.attr("data-product-id", location.productId);
      dropdownTrigger.attr("data-variant-id", location.variantId);

      dropdownTrigger
        .toggleClass("has-products", false)
        .toggleClass("js-action", true);

      return;
    }

    // If multiple locations are matched, ensure only matching dropdown options are displayed

    // Hide all dropdown options
    const locationDropdownOptions = dropdownOptionsWrapper.find(
      "medispa-dropdown-item__hitpoint",
    );

    if (!locationDropdownOptions.length) return;

    locationDropdownOptions.hide();

    // Show only matched dropdown options
    matchedLocations.forEach(function (location) {
      jQuery(location.element).show();
      window.productData.push(
        jQuery(location.element).data("product"),
      );
    });
  }

  this.filterLocations = function (location) {
    const bookingsWrapper = jQuery(".booking-wrapper").eq(0);

    if (!bookingsWrapper.length) return;

    const dropdownOptionsWrapper = bookingsWrapper.find(
      ".medispa-dropdown-options",
    );

    if (!dropdownOptionsWrapper.length) return;

    const locationDropdownOptions = dropdownOptionsWrapper.find(
      ".medispa-dropdown-item__hitpoint",
    );

    if (!locationDropdownOptions.length) return;

    // Filter location dropdown options
    const matchedLocations = locationDropdownOptions.get().reduce(function (
      all,
      elem,
    ) {
      const locationOption = jQuery(elem);
      const locationOptionText = locationOption.text().toLowerCase();

      if (!locationOptionText.includes(location.toLowerCase())) return all;

      all.push({
        element: elem,
        productId: elem.getAttribute("data-product-id"),
        variantId: elem.getAttribute("data-variant-id"),
      });

      return all;
    }, []);

    if (!matchedLocations.length) return;

    updateDropdownData(matchedLocations);
  };

  this.init = function () {
    // Check query string for location, if it exists, set the location filter
    var location = self.getQueryStringValue("location");
    if (location) {
      self.filterLocations(location);
    }
  };
}

$(document).ready(function () {
  window.medispaLocationsFilter = new MedispaLocationsFilter();
  window.medispaLocationsFilter.init();
});
